import React, { useState } from "react";
import { Button } from "@mui/material";

const Projects = () => {
  const [activeFilter, setActiveFilter] = useState("All");

  const projects = [
    {
      id: 1,
      image: require("../../Assets/project1.png"),
      date: "Feb 25, 2024",
      title: "School targeted recycle team of up to 50 group",
      status: "ongoing",
    },
    {
      id: 2,
      image: require("../../Assets/project2.png"),
      date: "May 10, 2023",
      title: "Enhancing the sustainability of paper recycling",
      status: "finished",
    },
    {
      id: 3,
      image: require("../../Assets/project3.png"),
      date: "Jul 10, 2023",
      title: "Sustainable Environmental Remediation",
      status: "ongoing",
      dimensions: "406 × 271",
    },
  ];

  const filters = ["All", "Ongoing", "Finished"];

  const filteredProjects = projects.filter((project) => {
    if (activeFilter === "All") return true;
    return project.status === activeFilter.toLowerCase();
  });

  return (
    <div className="bg-gray-50 py-16 px-4" id="projects" data-aos="fade-up">
      {/* Header */}
      <div className="max-w-6xl mx-auto display-flex flex-col items-center justify-center">
        <h2 className="text-3xl font-light text-gray-700 text-center mb-8">
          Project
        </h2>

        {/* Filter Buttons */}
        <div className="flex justify-start gap-2 mb-12">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={`px-6 py-2 rounded-xl text-sm font-medium transition-all duration-300 ${
                activeFilter === filter
                  ? "bg-[#8A9A5B] text-white shadow-md"
                  : "bg-white text-gray-600 hover:bg-gray-100 border border-gray-200"
              }`}
            >
              {filter}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {filteredProjects.map((project) => (
            <div
              key={project.id}
              className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden group"
            >
              {/* Image Container */}
              <div className="relative overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-52 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                {project.dimensions && (
                  <div className="absolute top-3 right-3">
                    <span className="bg-blue-500 text-white text-xs px-2 py-1 rounded">
                      {project.dimensions}
                    </span>
                  </div>
                )}
                {project.id === 3 && (
                  <div className="absolute inset-0 border-2 border-dashed border-blue-400 m-2 rounded-lg opacity-70"></div>
                )}
              </div>

              {/* Content */}
              <div className="p-6">
                <p className="text-sm text-gray-500 mb-3">{project.date}</p>
                <h3 className="text-lg font-semibold text-gray-800 mb-4 leading-snug">
                  {project.title}
                </h3>
                <button className="text-gray-600 text-sm font-medium hover:text-blue-700 transition-colors">
                  Learn more
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* View More Button */}
        <Button
          variant="contained"
          className="learn-more-button justify-center mx-auto flex items-center"
          sx={{
            backgroundColor: "rgba(138, 154, 91, 1)",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 1)",
              color: "rgba(138, 154, 91, 1)",
            },
            borderRadius: "50px",
            padding: "10px 20px",
            fontSize: "16px",
          }}
        >
          View More{" "}
          <img
            src={require("../../Assets/recycle.png")}
            alt="arrow"
            className="ml-2 arrow-icon"
            style={{ width: "5vmin" }}
          />
        </Button>
      </div>
    </div>
  );
};

export default Projects;
